// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3E8nt","footer":"ReportModalFilter_footer__2lS39"};